/** Keep this boundary aligned with the API's workspace-sensitive-input guard. */
export function containsSensitiveAssistantInput(value: string): boolean {
  return (
    /password|\bapi[ -]?key\b|\bsecret\b|\btoken\b|authorization|bearer|\bcredential/i.test(
      value,
    ) ||
    /(?:^|[^a-zA-Z0-9])(?:sk-(?:(?:proj|svcacct)-)?[a-zA-Z0-9_-]{8,}|gh[pousr]_[a-zA-Z0-9_]{12,}|github_pat_[a-zA-Z0-9_]{12,}|xox[baprs]-[a-zA-Z0-9-]{8,}|eyJ[a-zA-Z0-9_-]{8,}\.[a-zA-Z0-9_-]{8,}\.[a-zA-Z0-9_-]{8,})(?=$|[^a-zA-Z0-9_-])/u.test(
      value,
    )
  );
}

export const sensitiveAssistantInputMessage =
  'Keep passwords, API keys and tokens out of chat. Use the protected configuration fields instead.';
